import React from "react";
import "./Icons.scss";

const Icon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 17 17"
      className="icon-facebook"
    >
      <g id="Graphics">
        <g className="cls-2">
          <path
            className="cls-3"
            d="M15.94,8.58A7.12,7.12,0,1,1,8.82,1.46a7.12,7.12,0,0,1,7.12,7.12"
          />
          <path
            className="cls-3"
            d="M13.22,6.35a2.32,2.32,0,0,0-.72-1.52,2.46,2.46,0,0,0-1.64-.67,32.25,32.25,0,0,0-4.42,0A2.26,2.26,0,0,0,4.5,6a25.52,25.52,0,0,0,0,5,2.28,2.28,0,0,0,1.8,1.95,26.37,26.37,0,0,0,4.95,0,2.27,2.27,0,0,0,2-1.79,28.71,28.71,0,0,0,.06-4.81m-.82,4.47A1.51,1.51,0,0,1,11,12.17a26.33,26.33,0,0,1-4.62-.06,1.47,1.47,0,0,1-1.11-1.27,29.49,29.49,0,0,1,0-4.51A1.5,1.5,0,0,1,6.67,5a32.29,32.29,0,0,1,4.4,0,1.52,1.52,0,0,1,1.35,1.43,32.2,32.2,0,0,1,0,4.39M8.82,6.29a2.29,2.29,0,1,0,2.3,2.29,2.29,2.29,0,0,0-2.3-2.29m0,3.77A1.48,1.48,0,1,1,10.3,8.59a1.48,1.48,0,0,1-1.49,1.47M11.74,6.2a.54.54,0,1,1-.53-.54.54.54,0,0,1,.53.54"
          />
          <path
            className="cls-4"
            d="M13.22,6.35a2.32,2.32,0,0,0-.72-1.52,2.46,2.46,0,0,0-1.64-.67,32.25,32.25,0,0,0-4.42,0A2.26,2.26,0,0,0,4.5,6a25.52,25.52,0,0,0,0,5,2.28,2.28,0,0,0,1.8,1.95,26.37,26.37,0,0,0,4.95,0,2.27,2.27,0,0,0,2-1.79,28.71,28.71,0,0,0,.06-4.81m-.82,4.47A1.51,1.51,0,0,1,11,12.17a26.33,26.33,0,0,1-4.62-.06,1.47,1.47,0,0,1-1.11-1.27,29.49,29.49,0,0,1,0-4.51A1.5,1.5,0,0,1,6.67,5a32.29,32.29,0,0,1,4.4,0,1.52,1.52,0,0,1,1.35,1.43,32.2,32.2,0,0,1,0,4.39M8.82,6.29a2.29,2.29,0,1,0,2.3,2.29,2.29,2.29,0,0,0-2.3-2.29m0,3.77A1.48,1.48,0,1,1,10.3,8.59a1.48,1.48,0,0,1-1.49,1.47M11.74,6.2a.54.54,0,1,1-.53-.54.54.54,0,0,1,.53.54"
          />
        </g>
      </g>
    </svg>
  );
};

export default Icon;
